import { lazy } from 'react';
import { Permission } from '@condo/domain';
import { Navigate } from 'react-router-dom';

const AgentsLayout = lazy(() => import('./AgentsLayout'));
const ConversationsPage = lazy(() => import('./ConversationsPage'));
const ModelsPage = lazy(() => import('./ModelsPage'));

export const agentRoutes = [
    {
        path: 'agents',
        element: <AgentsLayout />,
        children: [
            {
                index: true,
                element: <Navigate to="/agents/conversations" replace />,
                permissions: [Permission.AgentChatViewAny, Permission.AgentFeedbackManage],
            },
            {
                path: 'conversations',
                name: 'agents.conversations',
                element: <ConversationsPage />,
                permissions: [Permission.AgentChatViewAny, Permission.AgentFeedbackManage],
            },
            { path: 'models', name: 'agents.models', element: <ModelsPage />, permissions: [Permission.AgentModelsManage] },
        ],
    },
];
